// @ts-check
import createStringFacet from '../createStringFacet';

export default createStringFacet({
  stateKey: 'priceRanges',
  itemKey: 'pricing.priceRangeRaw',
  configKey: 'filterPriceRange',
  sortBy: 'value',
  sortDirection: 'asc',
});
